import React, { useContext } from "react";
import { Select, MenuItem, FormControl } from "@material-ui/core";
import Extent from "@arcgis/core/geometry/Extent";
import "./GeoSelector.scss";
import { MapContext } from "../../context/MapContext";
import geometries from "../../constants/geometries";
import { LayoutContext } from "../../context/LayoutContext";
import { GeoContext } from "../../context/GeoContext";

function GeoSelector(props) {
  const { handleOnChange } = props;
  const [mapObject] = useContext(MapContext);
  const {mobileActive} = useContext(LayoutContext);
  const {selections, selectedGeometry} = useContext(GeoContext);

  const handleSelectChange = (e) => {
    const selectedGeometry = geometries.find((geo) => geo.name === e.target.value);
    mapObject.view.goTo(new Extent(selectedGeometry.extent));
    handleOnChange(e.target.value);
  };

  // if selections are provided, only allow those that match
  const choices = geometries.filter(
    (g) => !selections || selections.includes(g.name)
  );

  return (
    <div className="geoSelector">
      <FormControl>
      {!mobileActive && 
        <div className="selectInstructions">Select Geography:</div>}
      <Select
        native={mobileActive}
        onChange={handleSelectChange}
        className="select"
        id="geoSelect"
        variant="outlined"
        value={selectedGeometry}
      >
        {!mobileActive
        ? choices.map((geo) => (
          <MenuItem key={geo.name} value={geo.name}>
            {geo.name}
          </MenuItem>
        ))
        : choices.map((geo) => (
          <option key={geo.name} value={geo.name}>
            {geo.name}
          </option>
        ))}
      </Select>
      </FormControl>
    </div>
  );
}

export default GeoSelector;
